import { useState, useEffect } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [versionInfo, setVersionInfo] = useState(null);

  useEffect(() => {
    fetch(`${API}/api/version`)
      .then(r => r.json())
      .then(d => setVersionInfo(d))
      .catch(() => {});
  }, []);

  return (
    <footer className="footer-subtle" data-testid="app-footer">
      <span>&copy; {currentYear} Nirman Developers. All rights reserved.</span>
      {versionInfo && (
        <span className="text-slate-500 ml-2" data-testid="app-version" title={`Build: ${versionInfo.build_date}`}>
          v{versionInfo.version} &middot; {versionInfo.build_date}
        </span>
      )}
    </footer>
  );
};

export default Footer;
